var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFinance = function SvgFinance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86.49,76.54C70.35,72.34,65.16,68,65.16,61.25c0-7.75,7.18-13.16,19.2-13.16,10.1,0,15.15,3.84,17,10a6.58,6.58,0,0,0,6.18,5h2.14a6.75,6.75,0,0,0,6.4-9c-3-8.4-10-15.36-21-18.07V31a10.67,10.67,0,1,0-21.34,0v4.69c-13.79,3-24.89,12-24.89,25.67C48.8,77.82,62.39,86,82.23,90.76,100,95,103.56,101.28,103.56,107.9c0,4.9-3.48,12.73-19.2,12.73-11.73,0-17.78-4.2-20.12-10.17a7,7,0,0,0-6.4-4.77h-2a6.78,6.78,0,0,0-6.32,9.25c4,9.88,13.51,15.71,24.17,18v4.76a10.67,10.67,0,0,0,21.34,0v-4.62c13.86-2.63,24.89-10.67,24.89-25.24C119.92,87.63,102.64,80.73,86.49,76.54Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/finance.82d16f2f.svg";
export { ForwardRef as ReactComponent };